function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 1024 118"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F05D24",
  d: "M198 260q-2 2-2 4.85 0 2.85 2 4.9 2 2 4.85 2 2.85 0 4.85-2 2-2.05 2-4.9 0-2.85-2-4.85-2-2-4.85-2-2.85 0-4.85 2z",
  id: "a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.2 277.65h-10.7v49.85h10.7v-49.85z",
  id: "b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.75 296.5q0-8.95-4.9-14.05-4.95-5.15-13.65-5.15-13.25 0-18.35 9.9v-9.55H224.1v49.85h10.75V301q.6-6 4.25-9.7 3.85-3.85 9.9-3.9 5.6 0 8.8 3.25 3.2 3.2 3.2 8.85v28h10.75v-31z",
  id: "c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.65 327.5V258H322.9v28.3q-5.7-9.1-17.7-9.1-10.55 0-17.1 7-6.6 6.95-6.6 18.2 0 11.4 6.55 18.45 6.6 7.1 17.35 7.1 5.9 0 10.4-2.3 4.4-2.3 7.1-6.7v8.55h10.75m-37.05-36.55q4.3-4.6 11-4.6 6.75 0 11.05 4.6 4.25 4.55 4.25 11.8 0 7.1-4.25 11.65-4.3 4.55-11.05 4.55-6.75 0-11.05-4.55-4.2-4.5-4.3-11.65.1-7.2 4.35-11.8z",
  id: "d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.9 277.65h-10.75v31q0 8.95 4.85 14.05 4.85 5.15 13.4 5.15 12.9-.15 17.8-10.1v9.75h10.75v-49.85H382.2v24.55q0 6.7-3.6 10.95-3.75 4.45-10.1 4.6-5.4 0-8.5-3.25-3.1-3.2-3.1-8.85v-28z",
  id: "e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429.3 277.3q-11.1 0-18.1 7.05-7 7.05-7 18.3t7 18.25q7 6.95 18.1 6.95 7 0 12.45-2.4 5.3-2.35 8.7-6.85l-6-6q-5.15 6-14.7 6-6.5 0-10.6-4.45-4.2-4.45-4.2-11.5t4.2-11.5q4.1-4.4 10.6-4.4 8.6-.15 14.25 5.6l5.9-6.9q-7.15-8.15-20.6-8.15z",
  id: "f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293 29.6v-8.05h-14.7V7.85h-10.65v13.7h-7v8.05h7v25.85q0 7.25 4.15 11.1 3.75 3.4 9.8 3.4 6.2 0 12.25-3.65l-2.7-8.25q-4.45 2.15-7.5 2.15-2.65 0-3.95-1.45-1.4-1.6-1.4-5.3V29.6H293z",
  id: "g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.05 282.25q-3.35-2.35-8.05-3.7-4.6-1.35-9.35-1.35-7.8 0-12.75 3.4-5.6 3.85-5.6 11-.05 6.1 4.05 9.7 2.85 2.5 8.95 4.5 8.1 2.55 9 3 4.1 2 4.1 5.3 0 2.7-2.35 4.1-2.15 1.25-5.8 1.25-4.15 0-8.75-1.65-4.75-1.75-7.9-4.55l-3.85 7.65q3.7 3.3 9.15 5.15 5.3 1.8 10.9 1.8 8.1 0 13.3-3.55 5.8-4 5.8-11.25.05-6.1-4.1-9.8-2.95-2.65-9.05-4.65l-9.1-3q-4.15-1.85-4.15-4.85 0-2.55 2.1-3.8 1.85-1.15 5.2-1.15 3.3 0 7.2 1.2 3.85 1.2 7.15 3.2l3.9-7.95z",
  id: "h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641 285.25q-5.95-7.95-18.75-7.95-11.1.1-18.1 7.05-7.05 7.05-7.05 18.3 0 11.3 6.95 18.25 7 6.95 18.5 6.95 6.35 0 11.7-2.2 5.2-2.15 8.9-6.2l-5.7-6.1q-5.65 5.8-14.05 5.8-5.9 0-10.05-3.35-4.1-3.35-5.4-9.1h37.65q1-13.95-4.6-21.45m-28.4 4.15q3.9-3.5 9.75-3.5 6.15 0 9.85 3.45 3.75 3.45 4 9.5h-28.45q.95-6 4.85-9.45z",
  id: "i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M685.95 277.3q-13.25 0-18.35 9.9v-9.55h-10.8v49.85h10.8V301q.6-6 4.25-9.7 3.85-3.85 9.9-3.9 5.6 0 8.75 3.25 3.2 3.2 3.2 8.85v28h10.8v-31q0-8.95-4.9-14.05-4.95-5.15-13.65-5.15z",
  id: "j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M751.2 282.25q-3.35-2.35-8.05-3.7-4.6-1.35-9.35-1.35-7.8 0-12.75 3.4-5.6 3.85-5.6 11-.05 6.1 4.05 9.7 2.85 2.5 8.95 4.5 8.1 2.55 9 3 4.1 2 4.1 5.3 0 2.7-2.35 4.1-2.15 1.25-5.8 1.25-4.15 0-8.75-1.65-4.75-1.75-7.9-4.55l-3.85 7.65q3.7 3.3 9.15 5.15 5.3 1.8 10.9 1.8 8.1 0 13.3-3.55 5.8-4 5.8-11.25.05-6.1-4.1-9.8-2.95-2.65-9.05-4.65l-9.1-3q-4.15-1.85-4.15-4.85 0-2.55 2.1-3.8 1.85-1.15 5.2-1.15 3.3 0 7.2 1.2 3.85 1.2 7.15 3.2l3.9-7.95z",
  id: "k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M802.15 285.25q-5.95-7.95-18.75-7.95-11.1.1-18.1 7.05-7.05 7.05-7.05 18.3 0 11.3 6.95 18.25 7 6.95 18.5 6.95 6.35 0 11.7-2.2 5.2-2.15 8.9-6.2l-5.7-6.1q-2.75 2.8-6.35 4.3-3.65 1.5-7.7 1.5-5.9 0-10.05-3.35-4.1-3.35-5.4-9.1h37.65q1-13.95-4.6-21.45m-28.45 4.15q3.9-3.5 9.8-3.5 6.15 0 9.85 3.45 3.75 3.45 4 9.5H768.9q.9-6 4.8-9.45z",
  id: "l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.55 277.4q-10.55 0-17.95 7.45-7.45 7.4-7.45 17.9 0 10.5 7.45 17.95 7.4 7.45 17.95 7.45 10.5 0 17.95-7.45 7.4-7.45 7.4-17.95t-7.4-17.9q-7.45-7.45-17.95-7.45m-10.2 15.15q4.2-4.25 10.2-4.25 5.95 0 10.2 4.25 4.25 4.25 4.25 10.2 0 6-4.25 10.25-4.25 4.2-10.2 4.2-6 0-10.2-4.2-4.25-4.25-4.25-10.25 0-5.95 4.25-10.2z",
  id: "m"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  transform: "matrix(1.67719 0 0 1.67719 -328.441 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "matrix(1.67719 0 0 1.67719 -328.441 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g",
  transform: "matrix(1.67719 0 0 1.67719 -.887 .2)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#j",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#l",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#m",
  transform: "matrix(1.67719 0 0 1.67719 -329.615 -432.514)"
}));